import React from "react";
import { Button, Col, FormControl, FormLabel, Row } from "react-bootstrap";
import { DisplayBox } from "../../components";
import { ApiHelper, DateHelper, FeedInterface } from "../../helpers";

interface Props {
  feed: FeedInterface,
}

export const FeedStats: React.FC<Props> = props => {
  const sd = new Date();
  sd.setDate(sd.getDate() - 30);

  const [impressions, setImpressions] = React.useState<any[]>(null);
  const [startDate, setStartDate] = React.useState<Date>(sd);
  const [endDate, setEndDate] = React.useState<Date>(new Date());


  const handleChange = (e: any) => {
    switch (e.currentTarget.id) {
      case "startDate": setStartDate(DateHelper.convertToDate(e.currentTarget.value)); break;
      case "endDate": setEndDate(DateHelper.convertToDate(e.currentTarget.value)); break;
    }
  }

  const getRows = () => {
    const result: React.ReactElement[] = [];
    impressions?.forEach(i => {
      result.push(<tr>
        <td>{i.name}</td>
        <td>
          {i.totalImpressions}
        </td>
      </tr>)
    })
    if (result.length > 0) return result;
  }

  const populate = () => {
    const url = "/feeds/" + props.feed.id + "/impressions?startDate=" + DateHelper.formatDateTime(startDate, "yyyy-MM-dd") + "&endDate=" + DateHelper.formatDateTime(endDate, "yyyy-MM-dd")
    ApiHelper.get<any[]>(url).then(data => setImpressions(data || []));
  }



  const getTable = () => {
    if (impressions) {
      return (
        <table className="table table-sm">
          <tr><th>Message</th><th>Impressions</th></tr>
          {getRows()}
        </table>
      );
    }
  }


  return (
    <DisplayBox headerIcon="fas fa-satellite-dish" headerText={props.feed?.name + " Impressions"} >
      <Row>
        <Col sm={5}>
          <FormLabel>Start Date</FormLabel>
        </Col>
        <Col sm={5}>
          <FormLabel>End Date</FormLabel>
        </Col>
      </Row>
      <Row>
        <Col sm={5}>
          <FormControl id="startDate" type="date" value={DateHelper.formatDateTime(startDate, "yyyy-MM-dd")} onChange={handleChange} />
        </Col>
        <Col sm={5}>
          <FormControl id="endDate" type="date" value={DateHelper.formatDateTime(endDate, "yyyy-MM-dd")} onChange={handleChange} />
        </Col>
        <Col sm={2} className="d-grid">
          <Button variant="primary" className="w-100" onClick={(e) => { e.preventDefault(); populate(); }}>Update</Button>
        </Col>
      </Row>
      <br />
      {getTable()}
    </DisplayBox>
  );

};